import React, {useState, useEffect} from 'react'
import {Heading, Box, Container, Button} from "gestalt";
import "antd/dist/antd.css";
import {Slider} from "antd";
import "../styles/flash.css"

const peak_list = [0,
    0,
    0,
    0,
    0,
    0,
    0,
    0.5,
    0.5,
    0.5,
    0.5,
    0.5,
    0.5,
    0.5,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0.5,
    0.5,
    0]
const message_list = ["Energy is at its lowest price for the day",
    "Energy is at its lowest price for the day",
    "Energy is at its lowest price for the day",
    "Energy is at its lowest price for the day",
    "Energy is at its lowest price for the day",
    "Energy is at its lowest price for the day",
    "Energy is at its lowest price for the day",
    "Energy is starting to get expensive",
    "Energy is starting to get expensive",
    "Energy is starting to get expensive",
    "Energy is starting to get expensive",
    "Energy is starting to get expensive",
    "Energy is starting to get expensive",
    "Energy is starting to get expensive",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is most expensive right now, please consider waiting to use energy until after 9pm",
    "Energy is moderately expensive right now, consider waiting until after 11pm for even lower rates",
    "Energy is moderately expensive right now, consider waiting until after 11pm for even lower rates",
    "Energy is at its lowest price for the day",
]


const Display = ({match}) => {
    let zip = match.params.zip
    let type = match.params.type
    let bgcolor_array = ["#00a699", "#e4db73", "#ff5a5f"]
    let light_color_array = ["#0aa644", "#fddd1e", "#ff5a5f"]

    let [message, setMessage] = useState("Use Watt It Takes")
    let [bgColor, setBgColor] = useState("#00d2c1")
    let [time, setTime] = useState(0)
    let [flash, setFlash] = useState(false)
    let first = true;


    useEffect(() => {
        // Update the document title using the browser API
        getColor(0)
    }, [1]);


    function setLight(url, body, type) {
        return fetch(url, {
            method: type,
            headers: {
                "Authorization": "Bearer c55b709501016562bf4396134b95e95d9949e74bcfd367ee228c6312b9d8d7f9",
                "content-type": "application/json"
            },
            body: JSON.stringify(body)
        })
            .then(function (response) {
                if (response.status !== 200) {
                    console.log(`Request Status: ${response.status}`);
                    return;
                }
                return response.json().then(function (data) {
                    console.log("response returned")
                    console.log(JSON.stringify(data));
                    return data;
                });
            })
            .catch(function (error) {
                console.log('Request errored');
                console.log(error);
            });
    }

    function formatter(value) {
        return `${value}:00`;
    }


    const getColor = async (time) => {
        setTime(time)
        let index = calculateColor(time)
        let color = bgcolor_array[index]
        setMessage(message_list[time])
        if (color !== bgColor) {
            setLight("https://api.lifx.com/v1/lights/all/state", {
                color: light_color_array[index],
                fast: false,
                brightness: 0.5
            }, "PUT")
            setBgColor(color)
        }
    }

    const calculateColor = (time) => {
        const rates = peak_list

        let low = rates.reduce((previous, current) => current < previous ? current : previous, 10000000);
        let high = rates.reduce((previous, current) => current > previous ? current : previous, -10000000);
        let middle = rates.reduce((previous, current) => current > previous && current !== high ? current : previous, low);
        if (middle === low) {
            middle = null;
        }


        function color(time) {
            let rate = rates[time];
            if (rate === low) {
                return 0;
            } else if (rate === middle) {
                return 1;
            } else if (rate === high) {
                return 2;
            }
        }

        return color(time)
    }

    const makeFlash = () => {
        setFlash(true)
        setTimeout(() => {
            setFlash(false)
            setLight("https://api.lifx.com/v1/lights/all/state", {
                color: light_color_array[0],
                fast: false,
                brightness: 0.5
            }, "PUT")
        }, 10000)

        let flash_obj = {
            "color": "#FF0000",
            "from_color": "#000000",
            "period": 1,
            "cycles": 10,
            "persist": true,
            "power_on": true
        }
        setLight("https://api.lifx.com/v1/lights/all/effects/pulse", flash_obj, "POST")
    }


    return (
        <div
            style={flash ? {} : {
                "overflow": "hidden",
                "height": "100vh",
                "transition": "background-color 1s ease-in-out",
                "background": bgColor
            }}
            className={flash && 'flash'}
        >

            <Container>
                <Box margin={4} height={'100vh'} flex={'grow'} direction={'column'} justifyContent={'evenly'}
                     display={'flex'}>
                    <Box paddingY={6} flex={'grow'}>
                        <Heading size={'md'} color={'white'}>{time}:00</Heading>
                        <Heading size={'xs'} color={'white'}>{message}</Heading>

                    </Box>
                    <Box flex={'grow'}>
                        <Slider
                            min={0}
                            max={23}
                            onChange={getColor}
                            value={typeof time === 'number' ? time : 0}
                            tipFormatter={formatter}
                        />
                        <Button color="white" textColor="red" text="Alert" onClick={() => {
                            makeFlash()
                        }} inline/>
                    </Box>
                </Box>

            </Container>
        </div>
    )
};

export default Display